"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AWSS3Provider_1 = require("./AWSS3Provider");
exports.AWSS3Provider = AWSS3Provider_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@aws-amplify/storage/lib/Providers/index.js
// module id = 577
// module chunks = 0